export default __webpack_public_path__ + "static/noah-hologram-902f19694edefefa6e789b4aa4fb6143.png";